import { IconDeviceComputerCamera } from "@tabler/icons-react";

export const HiraStatus = () => {
  return (
    <div className="flex items-center">
      <div className="grow">
        <h4 className="text-sm">Hira Status</h4>
        <p className="text-muted-foreground text-xs">System Active</p>
      </div>
      <div>
        <IconDeviceComputerCamera className="size-4.5 text-lime-500" />
      </div>
    </div>
  );
};
